import { ProdInfo } from '@/config/types';
import { apiConfig } from '@/services/api-config';

export default async function (tokenKey: string, prod: ProdInfo) {
  return apiConfig
    .post(`api/user/create?tokenKey=${tokenKey}`, prod)
    .then((response) => response.data)
    .catch(() => false);
}
